import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const translations = {
  it: {
    app_name: "The First",
    app_subtitle: "Catalogo Supermercati",
    // Auth
    login_title: "Accedi",
    login_subtitle: "Inserisci il tuo nome e la password",
    your_name: "Nome",
    your_name_placeholder: "Es. Marco",
    password: "Password",
    password_placeholder: "Password",
    sign_in: "Entra",
    login_error: "Credenziali non valide",
    role: "Ruolo",
    role_owner: "Titolare",
    role_manager: "Direttore",
    select_your_store: "Seleziona il tuo punto vendita",
    destination: "Destinazione",
    destination_placeholder: "Es. Smaltimento, Beneficenza, Reso fornitore…",
    destination_required: "Destinazione obbligatoria",
    reserve: "Richiedi",
    reserve_from: "Richiedi da",
    reserved_quantity: "Quantità da richiedere",
    pickup_date: "Data di ritiro",
    reservation_created: "Richiesta inviata",
    reservations: "Richieste",
    reservations_incoming: "In arrivo",
    reservations_outgoing: "In uscita",
    reservations_history: "Storico",
    search_everywhere_placeholder: "Cerca un prodotto o un messaggio",
    collect: "Ritirato",
    reservation_collected: "Prenotazione ritirata",
    reservation_cancelled: "Prenotazione annullata",
    view_only: "Sola lettura",
    reserved_from_store: "Prenotato da",
    only_owner: "Solo il titolare può eseguire questa operazione",
    edit_quantity: "Modifica q.tà",
    reject: "Rifiuta",
    accept: "Accetta",
    reservation_confirmed: "Prenotazione accettata",
    reservation_status_pending: "In attesa",
    reservation_status_confirmed: "Accettata",
    reservation_status_collected: "Ritirata",
    reservation_status_cancelled: "Annullata",
    chat: "Chat",
    no_reservations: "Nessuna prenotazione",
    quantity_available: "Disponibili",
    logout: "Esci",
    exit_confirm_title: "Uscire dall'app?",
    exit_confirm_desc: "Dovrai reinserire nome e password al prossimo accesso.",
    exit: "Esci",
    welcome: "Benvenuto",
    welcome_f: "Benvenuta",
    change_image: "Cambia immagine",
    take_photo: "Scatta foto",
    from_gallery: "Dalla galleria",
    // Stores
    stores: "Punto vendita",
    stores_short: "Punti Vendita",
    select_store: "Seleziona negozio",
    store_jannelli: "Jannelli",
    store_mazzini: "Mazzini",
    store_materdomini: "Materdomini",
    store_parafarmacia: "Parafarmacia",
    enter: "Entra",
    articles: "articoli",
    updated_ago: "aggiornato",
    // Dashboard
    dashboard: "Home",
    catalog: "Catalogo",
    products: "Prodotti",
    problems: "Problemi",
    problems_short: "Problemi",
    expiries: "Scaduti",
    history: "Storico",
    open_problems: "Segnalazioni aperte",
    problems_count_1: "1 segnalazione da gestire",
    problems_count_n: "$ segnalazioni da gestire",
    no_problems_dash: "Nessuna segnalazione aperta",
    expired_products: "Prodotti scaduti",
    reports: "Report",
    // Products
    add_product: "Aggiungi",
    edit_product: "Modifica prodotto",
    new_product: "Nuovo articolo",
    product_detail: "Dettaglio articolo",
    name: "Nome articolo",
    article_code: "Codice articolo",
    barcode: "Codice EAN",
    barcode_optional: "Codice EAN (opzionale)",
    quantity: "Quantità",
    quantity_available: "Quantità disponibile",
    quantity_pieces: "$ pezzi",
    threshold_high: "Soglia alta (allerta overstock)",
    threshold_low: "Soglia bassa (scorta)",
    price: "Prezzo",
    cost: "Costo",
    category: "Categoria",
    notes: "Note",
    date_inserted: "Data di inserimento",
    image_url: "URL immagine",
    image_url_hint: "Incolla l'URL di un'immagine del prodotto",
    photo: "Foto",
    photo_optional: "Foto (opzionale)",
    edit_article: "Modifica Articolo",
    transfer_to: "Trasferisci a...",
    delete_article: "Elimina articolo",
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    edit: "Modifica",
    transfer: "Trasferisci",
    move_to_expired: "Sposta a Scaduti",
    move: "Sposta",
    scan_barcode: "Scansiona EAN",
    search: "Cerca articolo...",
    search_problem: "Cerca problema o supermercato...",
    no_products: "Nessun prodotto in questo negozio",
    confirm_delete: "Sei sicuro di voler eliminare?",
    pcs: "pz",
    select_all: "Seleziona tutti",
    selected_count_1: "1 selezionato",
    selected_count_n: "$ selezionati",
    total_expired: "ARTICOLI SCADUTI",
    expired_status: "Scaduto",
    all_years: "Tutti gli anni",
    all_months: "Tutti i mesi",
    month_1: "Gen",
    month_2: "Feb",
    month_3: "Mar",
    month_4: "Apr",
    month_5: "Mag",
    month_6: "Giu",
    month_7: "Lug",
    month_8: "Ago",
    month_9: "Set",
    month_10: "Ott",
    month_11: "Nov",
    month_12: "Dic",
    expiry_short: "Scadenza:",
    choose_store: "Scegli punto vendita...",
    send_report: "Invia Segnalazione",
    new_problem: "Nuova Segnalazione",
    problem_title_placeholder: "Es. Frigorifero guasto",
    problem_desc_placeholder: "Descrivi il problema...",
    describe_problem: "Descrivi il problema",
    active_only: "Attivi",
    // Filter chips
    filter_all: "Tutti",
    filter_expiring: "In scadenza",
    filter_low_stock: "0-20 pz",
    filter_medium_stock: "20-30 pz",
    filter_high_stock: "30+ pz",
    filter_active: "Attivi",
    filter_priority_high: "Priorità Alta",
    filter_priority_medium: "Priorità Media",
    filter_priority_low: "Priorità Bassa",
    // Transfer
    transfer_title: "Trasferisci prodotto",
    destination: "Destinazione",
    quantity_to_transfer: "Quantità da trasferire",
    transfer_done: "Trasferimento completato",
    merged_note: "Prodotto unito a quello esistente nella destinazione",
    // Problems
    add_problem: "Segnala",
    problem_title: "Titolo",
    description: "Descrizione",
    priority: "Priorità",
    priority_low: "Bassa",
    priority_medium: "Media",
    priority_high: "Alta",
    status: "Stato",
    status_open: "Da risolvere",
    status_in_progress: "In lavorazione",
    status_resolved: "Risolto",
    add_photos: "Aggiungi foto",
    no_problems: "Nessuna segnalazione",
    // Expiries
    add_expiry: "Aggiungi scadenza",
    expiry_date: "Data di scadenza",
    product_name: "Nome prodotto",
    no_expiries: "Nessun prodotto scaduto",
    days_left: "Giorni residui",
    expired: "Scaduto",
    // History
    audit_trail: "Registro operazioni",
    no_history: "Nessuna operazione registrata",
    action: "Azione",
    user: "Utente",
    when: "Quando",
    entity: "Elemento",
    action_created: "creato",
    action_updated: "aggiornato",
    action_deleted: "eliminato",
    action_transferred: "trasferito",
    action_moved_to_expired: "spostato in scaduti",
    action_login: "login",
    action_photo_added: "foto aggiunta",
    history_label_created: "NUOVO ARTICOLO",
    history_label_updated: "MODIFICA",
    history_label_deleted: "ELIMINAZIONE",
    history_label_transferred: "TRASFERIMENTO",
    history_label_moved_to_expired: "SPOSTATO A SCADUTI",
    history_label_photo_added: "FOTO AGGIUNTA",
    history_removed_from: "rimosso da",
    history_added_to: "aggiunto in",
    history_updated_in: "aggiornato in",
    history_moved_from: "spostato da",
    history_from_to: "da $ a $",
    history_by: "da",
    entity_product: "Prodotto",
    entity_problem: "Segnalazione",
    entity_expiry: "Scadenza",
    entity_auth: "Autenticazione",
    // Common
    loading: "Caricamento...",
    saving: "Salvataggio...",
    all_stores: "Tutti i negozi",
    close: "Chiudi",
    confirm: "Conferma",
    yes: "Sì",
    no: "No",
    total: "Totale",
    language: "Lingua",
    theme: "Tema",
    theme_auto: "Automatico (sistema)",
    theme_light: "Chiaro",
    theme_dark: "Scuro",
    theme_switch_title: "Seleziona tema",
    notif_enable: "Attiva notifiche",
    notif_disable: "Disattiva notifiche",
    notif_enabled: "Notifiche attivate",
    notif_disabled: "Notifiche disattivate",
    notif_failed: "Impossibile attivare le notifiche",
    notif_install_first: "Installa prima l'app sulla home per ricevere notifiche",
    barcode_hint: "Punta la fotocamera verso il codice a barre",
  },
  en: {
    app_name: "The First",
    app_subtitle: "Supermarket Catalog",
    login_title: "Sign in",
    login_subtitle: "Enter your name and the password",
    your_name: "Name",
    your_name_placeholder: "e.g. Marco",
    password: "Password",
    password_placeholder: "Password",
    sign_in: "Enter",
    login_error: "Invalid credentials",
    role: "Role",
    role_owner: "Owner",
    role_manager: "Manager",
    select_your_store: "Select your store",
    destination: "Destination",
    destination_placeholder: "e.g. Disposal, Charity, Return to supplier…",
    destination_required: "Destination required",
    reserve: "Request",
    reserve_from: "Request from",
    reserved_quantity: "Quantity to request",
    pickup_date: "Pickup date",
    reservation_created: "Request sent",
    reservations: "Requests",
    reservations_incoming: "Incoming",
    reservations_outgoing: "Outgoing",
    reservations_history: "History",
    search_everywhere_placeholder: "Cerca un prodotto o un messaggio",
    collect: "Collected",
    reservation_collected: "Reservation collected",
    reservation_cancelled: "Reservation cancelled",
    view_only: "Read only",
    reserved_from_store: "Reserved by",
    only_owner: "Only the owner can perform this action",
    edit_quantity: "Edit qty",
    reject: "Reject",
    accept: "Accept",
    reservation_confirmed: "Reservation accepted",
    reservation_status_pending: "Pending",
    reservation_status_confirmed: "Confirmed",
    reservation_status_collected: "Collected",
    reservation_status_cancelled: "Cancelled",
    chat: "Chat",
    no_reservations: "No reservations",
    quantity_available: "Available",
    logout: "Sign out",
    exit_confirm_title: "Exit the app?",
    exit_confirm_desc: "You'll need to enter name and password again next time.",
    exit: "Exit",
    welcome: "Welcome",
    welcome_f: "Welcome",
    change_image: "Change image",
    take_photo: "Take photo",
    from_gallery: "From gallery",
    stores: "Store",
    stores_short: "Stores",
    select_store: "Select store",
    store_jannelli: "Jannelli",
    store_mazzini: "Mazzini",
    store_materdomini: "Materdomini",
    store_parafarmacia: "Pharmacy",
    enter: "Enter",
    articles: "items",
    updated_ago: "updated",
    dashboard: "Home",
    catalog: "Catalog",
    products: "Products",
    problems: "Issues",
    problems_short: "Issues",
    expiries: "Expired",
    history: "History",
    open_problems: "Open issues",
    problems_count_1: "1 issue to handle",
    problems_count_n: "$ issues to handle",
    no_problems_dash: "No open issues",
    expired_products: "Expired products",
    reports: "Reports",
    add_product: "Add",
    edit_product: "Edit product",
    product_detail: "Product detail",
    name: "Name",
    article_code: "Article code",
    barcode: "Barcode (EAN)",
    quantity: "Quantity",
    threshold_high: "Overstock threshold",
    threshold_low: "Low-stock threshold",
    price: "Price",
    category: "Category",
    notes: "Notes",
    image_url: "Image URL",
    image_url_hint: "Paste a product image URL",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    transfer: "Transfer",
    move_to_expired: "Move to expired",
    scan_barcode: "Scan EAN",
    search: "Search item...",
    search_problem: "Search issue or store...",
    no_products: "No products in this store",
    confirm_delete: "Are you sure you want to delete?",
    pcs: "pcs",
    filter_all: "All",
    filter_expiring: "Expiring",
    filter_low_stock: "0-20 pcs",
    filter_medium_stock: "20-30 pcs",
    filter_high_stock: "30+ pcs",
    filter_active: "Active",
    filter_priority_high: "High priority",
    filter_priority_medium: "Medium priority",
    filter_priority_low: "Low priority",
    transfer_title: "Transfer product",
    destination: "Destination",
    quantity_to_transfer: "Quantity to transfer",
    transfer_done: "Transfer completed",
    merged_note: "Product merged with existing one at destination",
    add_problem: "Report",
    new_problem: "New issue",
    problem_title: "Title",
    description: "Description",
    priority: "Priority",
    priority_low: "Low",
    priority_medium: "Medium",
    priority_high: "High",
    status: "Status",
    status_open: "To resolve",
    status_in_progress: "In progress",
    status_resolved: "Resolved",
    add_photos: "Add photos",
    no_problems: "No issues",
    add_expiry: "Add expiry",
    expiry_date: "Expiry date",
    product_name: "Product name",
    no_expiries: "No expired products",
    days_left: "Days left",
    expired: "Expired",
    audit_trail: "Audit trail",
    no_history: "No operations recorded",
    action: "Action",
    user: "User",
    when: "When",
    entity: "Item",
    action_created: "created",
    action_updated: "updated",
    action_deleted: "deleted",
    action_transferred: "transferred",
    action_moved_to_expired: "moved to expired",
    action_login: "login",
    action_photo_added: "photo added",
    history_label_created: "NEW ITEM",
    history_label_updated: "EDIT",
    history_label_deleted: "DELETION",
    history_label_transferred: "TRANSFER",
    history_label_moved_to_expired: "MOVED TO EXPIRED",
    history_label_photo_added: "PHOTO ADDED",
    history_removed_from: "removed from",
    history_added_to: "added to",
    history_updated_in: "updated in",
    history_moved_from: "moved from",
    history_from_to: "from $ to $",
    history_by: "by",
    entity_product: "Product",
    entity_problem: "Issue",
    entity_expiry: "Expiry",
    entity_auth: "Auth",
    loading: "Loading...",
    saving: "Saving...",
    all_stores: "All stores",
    close: "Close",
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
    total: "Total",
    language: "Language",
    theme: "Theme",
    theme_auto: "Automatic (system)",
    theme_light: "Light",
    theme_dark: "Dark",
    theme_switch_title: "Choose theme",
    notif_enable: "Enable notifications",
    notif_disable: "Disable notifications",
    notif_enabled: "Notifications enabled",
    notif_disabled: "Notifications disabled",
    notif_failed: "Could not enable notifications",
    notif_install_first: "Install app to home first to receive notifications",
    barcode_hint: "Point the camera at the barcode",
  },
};

const I18nContext = createContext({ t: (k) => k, lang: "it", setLang: () => {} });

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("tf_lang") || "it");
  useEffect(() => localStorage.setItem("tf_lang", lang), [lang]);
  const setLang = useCallback((l) => setLangState(l), []);
  const t = useMemo(() => {
    const dict = translations[lang] || translations.it;
    return (key) => dict[key] ?? key;
  }, [lang]);
  const value = useMemo(() => ({ t, lang, setLang }), [t, lang, setLang]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);

export const STORE_LABELS = {
  jannelli: "store_jannelli",
  mazzini: "store_mazzini",
  materdomini: "store_materdomini",
  parafarmacia: "store_parafarmacia",
};

export const ALL_STORES = ["jannelli", "mazzini", "materdomini", "parafarmacia"];
